import React from 'react'

const Fourteen = () => {
    return (
        <div className='container'>
            <h1>Print NooB-Geeks ten 10 times.</h1>
            <p>
            Now we have to Print NooB-Geeks 10 times. By question we understood that we need loop 
here because we have to do a task in repetition. <br />
Now we 3 choices with loops So we'll do this question by for loop <br />

As we for loop has 3 contents initialization;condition;increament or decreament <br />
<h3> first step</h3>
we will take variable as i and initialize it by 0  in for loop you can choose any name
 for variabel except any keyword <br />
<h3> second step</h3>
As our question is demanding to print 10 time so,our condition will be i&lt;=10
<h3>third step</h3>
now we have to do increament of i by 1 every time to print it 10 times,</p>
<div className='containers'>
<code class="library">#include &lt;stdio.h&gt;</code> <br />
for (int i = 0; i &lt; 10; i++) <br />&#123; <br />
    printf("NooB-Geeks\n");<br />
    &#125;<br />
</div>
        </div>
    )
}

export default Fourteen
